import axios from "axios";
import { Message } from "element-ui";
import router from "@/router";

const service = axios.create({
  baseURL: "https://apighyx.zgyxszds.com/api/v1/supplier",
  timeout: 15000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("supplier_token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截器
let redirecting = false; // 防止重复跳转登录页
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.result === "ok") {
      return res.message || res.data || res;
    }
    // 登录过期 / 无权限：清除 token 并跳转登录页，避免无限请求
    if (res.code === 50002) {
      localStorage.removeItem("supplier_token");
      if (!redirecting && router.currentRoute.path !== "/login") {
        redirecting = true;
        router
          .push({ path: "/login" })
          .catch(() => {})
          .finally(() => {
            redirecting = false;
            window.location.reload();
          });
      }
      return Promise.reject(new Error(res.message || "登录状态已失效"));
    }
    Message.error(res.message || "请求失败");
    return Promise.reject(new Error(res.message || "请求失败"));
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("supplier_token");
      if (!redirecting && router.currentRoute.path !== "/login") {
        redirecting = true;
        router
          .push({ path: "/login" })
          .catch(() => {})
          .finally(() => {
            redirecting = false;
            window.location.reload();
          });
      }
    } else {
      Message.error(error.message || "网络错误");
    }
    return Promise.reject(error);
  },
);

// ==================== 登录 ====================
export function login(data) {
  return service.post("/login", data);
}
export function getUserInfo() {
  return service.get("/userInfo");
}
export function logout() {
  return service.post("/logout");
}

// ==================== 首页 ====================
export function getDashboard() {
  return service.get("/dashboard");
}

// ==================== 商品管理 ====================
export function getProducts(params) {
  return service.get("/products", { params });
}
export function createProduct(data) {
  return service.post("/products", data);
}
export function updateProduct(id, data) {
  return service.post("/products/" + id, data);
}
export function toggleProductStatus(data) {
  return service.post("/products/toggleStatus", data);
}
export function batchOnProducts(data) {
  return service.post("/products/batchOn", data);
}
export function batchOffProducts(data) {
  return service.post("/products/batchOff", data);
}
export function destroyProduct(id) {
  return service.post("/products/destroy/" + id);
}
// 托管商品（仅甄选专区商品可设置）
export function setCloudProduct(data) {
  return service.post("/products/setCloud", data);
}
export function cancelCloudProduct(data) {
  return service.post("/products/cancelCloud", data);
}

// ==================== 选品库 ====================
export function getSelection(params) {
  return service.get("/selection", { params });
}
export function applySelection(data) {
  return service.post("/selection/apply", data);
}
export function getSelectionApplications(params) {
  return service.get("/selection/applications", { params });
}
export function approveSelection(data) {
  return service.post("/selection/approve", data);
}
export function rejectSelection(data) {
  return service.post("/selection/reject", data);
}

// ==================== 订单 ====================
export function getOrders(params) {
  return service.get("/orders", { params });
}
export function getOrderDetail(params) {
  return service.get("/orders/detail", { params });
}
export function shipmentOrder(data) {
  return service.post("/orders/shipment", data);
}
export function refundOrder(data) {
  return service.post("/orders/refund", data);
}

// ==================== 会员 ====================
export function getMembers(params) {
  return service.get("/members", { params });
}
export function getMembersStats() {
  return service.get("/members/stats");
}
export function getMembersPerformance(params) {
  return service.get("/members/performance", { params });
}
export function getMembersSummary() {
  return service.get("/members/summary");
}
export function getMemberOrders(memberId) {
  return service.get("/members/" + memberId + "/orders");
}
export function getMemberLogs(memberId, params) {
  return service.get("/members/" + memberId + "/logs", { params });
}
export function setMemberLevel(data) {
  return service.post("/members/setLevel", data);
}

// ==================== 财务 ====================
export function getFinance() {
  return service.get("/finance");
}
export function getFinanceFlowList(params) {
  return service.get("/finance/flowList", { params });
}
export function getDebtList(params) {
  return service.get("/finance/debtList", { params });
}

// ==================== 提现 ====================
export function getWithdraw(params) {
  return service.get("/withdraw", { params });
}
export function applyWithdraw(data) {
  return service.post("/withdraw", data);
}
export function getWithdrawList(params) {
  return service.get("/withdraw/list", { params });
}

// ==================== 轮播图 ====================
export function getBanners(params) {
  return service.get("/banners", { params });
}
export function createBanner(data) {
  return service.post("/banners", data);
}
export function updateBanner(id, data) {
  return service.post("/banners/" + id, data);
}
export function destroyBanner(id) {
  return service.post("/banners/destroy/" + id);
}

// ==================== 售后管理 ====================
export function getAfterSales(params) {
  return service.get("/afterSale", { params });
}
export function getAfterSaleDetail(id) {
  return service.get("/afterSale/" + id);
}
export function auditAfterSale(data) {
  return service.post("/afterSale/audit", data);
}
export function signAfterSale(data) {
  return service.post("/afterSale/sign", data);
}

// ==================== 托管商品 ====================
export function getCloudWarehouse(params) {
  return service.get("/cloudWarehouse", { params });
}
export function getCloudWarehouseStats(params) {
  return service.get("/cloudWarehouse/stats", { params });
}

// ==================== 分身商设置 ====================
export function changePassword(data) {
  return service.post("/settings/changePassword", data);
}
export function updateDividendRatio(data) {
  return service.post("/settings/updateDividendRatio", data);
}
export function getBankCard() {
  return service.get("/settings/bankCard");
}
export function saveBankCard(data) {
  return service.post("/settings/bankCard", data);
}
export function updateInteractSection(data) {
  return service.post("/settings/updateInteractSection", data);
}
export function getShareConfig() {
  return service.get("/settings/shareConfig");
}
export function saveShareConfig(data) {
  return service.post("/settings/shareConfig", data);
}
export function getCommissionConfig() {
  return service.get("/settings/commissionConfig");
}
export function saveCommissionConfig(data) {
  return service.post("/settings/commissionConfig", data);
}

// ==================== RBAC 权限管理 ====================
// 管理员管理
export function getRbacAdmins(params) {
  return service.get("/rbac/admins", { params });
}
export function createRbacAdmin(data) {
  return service.post("/rbac/admins", data);
}
export function updateRbacAdmin(id, data) {
  return service.post(`/rbac/admins/${id}`, data);
}
export function deleteRbacAdmin(id) {
  return service.post(`/rbac/admins/destroy/${id}`);
}
export function checkRbacAdminUsername(data) {
  return service.post("/rbac/admins/check-username", data);
}
export function getRbacRolesAll() {
  return service.get("/rbac/roles-all");
}
export function getRbacBranches() {
  return service.get("/rbac/branches");
}

// 角色管理
export function getRbacRoles(params) {
  return service.get("/rbac/roles", { params });
}
export function getAllRoles() {
  return service.get("/rbac/roles/all");
}
export function createRbacRole(data) {
  return service.post("/rbac/roles", data);
}
export function updateRbacRole(id, data) {
  return service.post(`/rbac/roles/${id}`, data);
}
export function deleteRbacRole(id) {
  return service.post(`/rbac/roles/destroy/${id}`);
}

// 权限管理
export function getRbacPermissions(params) {
  return service.get("/rbac/permissions", { params });
}
export function getRbacPermissionTree() {
  return service.get("/rbac/permissions/tree");
}
export function createRbacPermission(data) {
  return service.post("/rbac/permissions", data);
}
export function updateRbacPermission(id, data) {
  return service.post(`/rbac/permissions/${id}`, data);
}
export function deleteRbacPermission(id) {
  return service.post(`/rbac/permissions/destroy/${id}`);
}

export default service;
